module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_m_normal.a59a3a4b.png";